/**
 * Escapes a value for HTML text and for quoted attribute values (both "..."
 * and '...'): & < > " and ' become entities. null and undefined become an
 * empty string, other values their String() form.
 */
export function escapeHtml(value: unknown): string {
    return String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}
